/* FRATERNAL — mobile menu toggle (Jalen 2026-10-16).

   The hamburger shipped with markup + CSS but NO behaviour: at <=749px `.nav` is
   display:none and `.hdr__menu` appears, and tapping it did nothing because nothing
   ever listened. This binds the button DIRECTLY (not document-delegated) so the tap
   lands on iOS Safari regardless of what else is on the page. */
(function () {
  var btn = document.querySelector('[data-frt-menu]');
  var nav = document.getElementById('frt-mnav');
  if (!btn || !nav) return;

  var BURGER = '☰';   // ☰
  var CLOSE  = '×';   // ×

  function set(open) {
    nav.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open ? CLOSE : BURGER;
    btn.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    set(nav.hidden);
  });

  // tapping a link closes it before navigation paints
  nav.addEventListener('click', function (e) {
    if (e.target.closest('a')) set(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') set(false);
  });

  // rotating to landscape / resizing past the breakpoint must not leave the panel
  // stranded open above a nav that is now visible again
  window.addEventListener('resize', function () {
    if (window.innerWidth > 749 && !nav.hidden) set(false);
  });
})();
